import React, {useMemo} from "react";
import EmailWhite from "../assets/public/email_white.svg";
import LogoWhite from "../assets/public/logo_white.svg";
import PhoneWhite from "../assets/public/phone_white.svg";
import WaWhite from "../assets/public/wa_white.svg";

const Footer = () => {

  const currentYear = useMemo(() => new Date().getFullYear(), []);

  return (
    <>
      <div className="mobile-view">
        <footer className="page-footer backdrop-opacity-10">
          <div className="grid grid-cols-1 place-items-center">
            <img src={LogoWhite} width="60%" alt="" />
          </div>

          <div>
            <div className="grid grid-cols-1 place-items-center">
              <div className="flex justify-center ...">
                <div>
                  <img
                    src={EmailWhite}
                    width="20px"
                    className="float-left"
                    alt=""
                  />
                  &nbsp;&nbsp;
                </div>
                <div>
                  <span style={{ fontSize: "15px" }}>info@magnetfx.co.id</span>
                </div>
              </div>
              <div className="mt-2 flex justify-center ...">
                <div>
                  <img
                    src={PhoneWhite}
                    width="20px"
                    className="float-left"
                    alt=""
                  />
                  &nbsp;&nbsp;
                </div>
                <div>
                  <a style={{ color: "white" }} href="tel:(021) 250 6336">
                    <span style={{ fontSize: "15px" }}>(021) 250 6336</span>
                  </a>
                </div>
              </div>
              <div className="mt-2 flex justify-center ...">
                <div>
                  <img
                    src={WaWhite}
                    width="20px"
                    className="float-left"
                    alt=""
                  />
                  &nbsp;&nbsp;
                </div>
                <div>
                  <a
                    style={{ color: "white" }}
                    href="https://api.whatsapp.com/send?phone=6287835355526&text=Halo"
                  >
                    <span style={{ fontSize: "15px" }}>0878-3535-5526</span>
                  </a>
                </div>
              </div>
              <div className="mt-2 flex justify-center ...">
                <div>
                  <span style={{ fontSize: "14px" }}>
                    &copy; 2021 - {currentYear} www.magnetfx.co id – All Rights Reserved
                  </span>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
      <div className="mobile-hide">
        <footer className="page-footer backdrop-opacity-10">
          <div className="mobile-hide grid grid-cols-6">
            <div className="show_hide">
              <img src={LogoWhite} width="180px" alt="" />
            </div>

            <div className="show_hide col-span-3 ml-6">
              <div className="grid grid-cols-4">
                <div className="w-[100%] col-span-2">
                  <img
                    src={EmailWhite}
                    width="20px"
                    className="float-left"
                    alt=""
                  />
                  &nbsp;
                  <span style={{ fontSize: "15px" }}>info@magnetfx.co.id</span>
                </div>

                <div>
                  <img
                    src={PhoneWhite}
                    width="20px"
                    className="float-left"
                    alt=""
                  />
                  &nbsp;
                  <a style={{ color: "white" }} href="tel:(021) 250 6336">
                    <span style={{ fontSize: "15px" }}>(021) 250 6336</span>
                  </a>
                </div>

                <div>
                  <img
                    src={WaWhite}
                    width="20px"
                    className="float-left"
                    alt=""
                  />
                  &nbsp;
                  <a
                    style={{ color: "white" }}
                    href="https://api.whatsapp.com/send?phone=6287835355526&text=Halo"
                  >
                    <span style={{ fontSize: "15px" }}>0878-3535-5526</span>
                  </a>
                </div>

                <div className="mobile-hide col-span-3 pt-2">
                  &copy; 2021 - {currentYear} www.magnetfx.co.id – All Rights Reserved
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Footer;
